export default {

  get() {
    return window.localStorage.getItem('moqo-api-token')
  },

  set (value) {
    if (!value) {
      window.localStorage.removeItem('moqo-api-token')
    } else {
      window.localStorage.setItem('moqo-api-token', value)
    }
  },

  httpHeaders() {
    return {
        'Authorization': this.get()
    }
  }

}